import { css } from "@emotion/css";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import { Layout } from "antd";
import { useState } from "react";
import AdminMenu from "./AdminMenu/AdminMenu";
import SidebarMenu from "./SidebarMenu";
const { Header, Sider, Content } = Layout;

function OwnLayout() {
  const currentUser = useSelector((s) => s?.user?.data);
  const isAdmin = currentUser?.user?.roles?.some((s) => s?.name === "admin");

  const [collapsed, setCollapsed] = useState(false);
  const OwnLayoutStyles = css`
    .ant-layout {
      background-color: ${isAdmin ? "#EEF0FF" : "#fbfbff"};
      .ant-layout-content {
        // display: flex;
        // align-items: center;
        // justify-content: center;
      }
    }
  `;

  return (
    <div className={OwnLayoutStyles}>
      <Layout>
        <Layout className="min-h-screen overflow-hidden">
          {isAdmin ? (
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              width={"280px"}
              className=""
            >
              <AdminMenu collapsed={collapsed} setCollapsed={setCollapsed} />
            </Sider>
          ) : (
            <Header className="">
              <SidebarMenu />
            </Header>
          )}

          <Layout className={`container`}>
            <Content className={`layout-content-wrapper`}>
              <div className="pt-[42px] pb-3">
                <Outlet />
              </div>
            </Content>
          </Layout>

          {/* <TourOverview /> */}
        </Layout>
      </Layout>
    </div>
  );
}

export default OwnLayout;
